// Module
var code = "<md-dialog class=\"loading-dialog\" aria-label=\"loading\"> <md-dialog-content layout=\"column\" layout-align=\"center center\"> <div> <i class=\"ck ck-loading fa fa-spin fa-4x ck-green\"></i> </div> </md-dialog-content> </md-dialog> ";
// Exports
module.exports = code;